/**
 *  Created by piotr@revisual.io on 04/08/2025
 */
import React, { useCallback } from "react";
import { ReactMultiEmail, isEmail } from "react-multi-email";
import classNames from "classnames";

/**
 *
 * @param {Object} form
 * @param {function} setFormField
 * @param {Object} errors
 * @returns {Element}
 * @constructor
 */
export const AddMembersStep = ({ form, setFormField, errors }) => {
  const [emails, setEmails] = React.useState(form.emails || []);
  const [focused, setFocused] = React.useState(false);

  const onSetFocus = useCallback(
    (value) => (e) => {
      setFocused(value);
    },
    [focused]
  );

  const onEmailChange = useCallback(
    (_emails) => {
      const validEmails = _emails.filter((email) => isEmail(email));
      setEmails(validEmails);
      setFormField("emails")(validEmails);
    },
    [setFormField, setEmails, form]
  );

  const getLabel = useCallback(
    (email, index, removeEmail) => {
      return (
        <div data-tag key={index}>
          <div data-tag-item>{email}</div>
          <span data-tag-handle onClick={() => removeEmail(index)}>
            ×
          </span>
        </div>
      );
    },
    [emails]
  );

  return (
    <div>
      <h3 className="account-title">Invite your team members</h3>
      <p className="text-muted">
        Invite your team members to collaborate on your widgets.
      </p>
      <form>
        <div className="form-group">
          <label>Email addresses, comma separated</label>

          <ReactMultiEmail
            placeholder="Add team members emails"
            className={classNames("form-control", {
              "is-invalid": errors.emails,
            })}
            emails={emails}
            onChange={onEmailChange}
            autoFocus={true}
            onFocus={onSetFocus(true)}
            onBlur={onSetFocus(false)}
            getLabel={getLabel}
          />
          <small className={"text-danger"}>{errors.emails}</small>
        </div>
      </form>
    </div>
  );
};

export default AddMembersStep;
